import theme from '../../base';

const select = {
  background: theme.colors.neutrals.gray850,
  border: theme.colors.neutrals.gray700,
  foreground: theme.colors.neutrals.gray200,
  icon: theme.colors.neutrals.gray200,
  labelForeground: theme.colors.neutrals.white,
  disabled: {
    background: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray700,
    foreground: theme.colors.neutrals.gray700,
    icon: theme.colors.neutrals.gray700,
  },
  focus: {
    border: theme.colors.blues.blue200,
  },
  error: {
    border: theme.colors.reds.red300,
  },
};

export default select;
